import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/shared/PasswordInput";
import { Label } from "@/components/ui/label";
import { PasswordStrength } from "@/components/PasswordStrength";

export default function Register() {
  const [form, setForm] = useState({ company_name: "", ico: "", name: "", email: "", password: "" });
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { applyAuth } = useAuth();
  const nav = useNavigate();

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const mismatch = confirm.length > 0 && confirm !== form.password;

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== confirm) { setError("Hesla se neshodují."); return; }
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/register", form);
      applyAuth(data);
      nav("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell title="Registrace firmy" subtitle="Vytvořte účet a získejte 14 dní zdarma">
      <form onSubmit={submit} className="space-y-3.5">
        <div>
          <Label htmlFor="company_name">Název firmy</Label>
          <Input id="company_name" data-testid="reg-company" value={form.company_name} onChange={set("company_name")} className="h-12 mt-1.5" required />
        </div>
        <div>
          <Label htmlFor="ico">IČO (nepovinné)</Label>
          <Input id="ico" data-testid="reg-ico" value={form.ico} onChange={set("ico")} className="h-12 mt-1.5" />
        </div>
        <div>
          <Label htmlFor="name">Vaše jméno</Label>
          <Input id="name" data-testid="reg-name" value={form.name} onChange={set("name")} className="h-12 mt-1.5" required />
        </div>
        <div>
          <Label htmlFor="email">E-mail</Label>
          <Input id="email" data-testid="reg-email" type="email" value={form.email} onChange={set("email")} className="h-12 mt-1.5" required />
        </div>
        <div>
          <Label htmlFor="password">Heslo</Label>
          <PasswordInput id="password" data-testid="reg-password" value={form.password} onChange={set("password")} className="h-12 mt-1.5" minLength={10} required />
          <PasswordStrength password={form.password} />
        </div>
        <div>
          <Label htmlFor="password2">Heslo znovu</Label>
          <PasswordInput id="password2" data-testid="reg-password2" value={confirm} onChange={(e) => setConfirm(e.target.value)}
            className={`h-12 mt-1.5 ${mismatch ? "border-destructive focus-visible:ring-destructive" : ""}`} minLength={10} required />
          {mismatch && <p data-testid="reg-password-mismatch" className="text-destructive text-xs mt-1">Hesla se neshodují.</p>}
        </div>
        {error && <div data-testid="reg-error" className="text-destructive text-sm">{error}</div>}
        <Button type="submit" disabled={loading} data-testid="reg-submit" className="w-full h-12 text-base font-bold">
          {loading ? "Vytvářím…" : "Vytvořit účet"}
        </Button>
        <p className="text-sm text-muted-foreground text-center pt-1">
          Máte účet? <Link to="/login" className="text-brand font-semibold hover:underline">Přihlásit se</Link>
        </p>
      </form>
    </AuthShell>
  );
}
